import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

interface ContactDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onSubmit: (contactInfo: {
    name: string;
    email: string;
    company: string;
  }) => void;
  loading?: boolean;
}

export const ContactDialog = ({
  open,
  onOpenChange,
  onSubmit,
  loading = false,
}: ContactDialogProps) => {
  const [contactInfo, setContactInfo] = React.useState(() => {
    const savedInfo = localStorage.getItem('talentful_contact_info');
    return savedInfo ? JSON.parse(savedInfo) : {
      name: "",
      email: "",
      company: "",
    };
  });

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    localStorage.setItem('talentful_contact_info', JSON.stringify(contactInfo));
    onSubmit(contactInfo);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-sm sm:max-w-lg px-1 py-2">
        <DialogHeader className="mb-2 mt-1 sm:mt-0">
          <DialogTitle>Enter your details to see results</DialogTitle>
        </DialogHeader>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor="name">Name *</Label>
            <Input
              id="name"
              value={contactInfo.name}
              onChange={(e) =>
                setContactInfo((prev) => ({ ...prev, name: e.target.value }))
              }
              required
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="email">Email *</Label>
            <Input
              id="email"
              value={contactInfo.email}
              onChange={(e) =>
                setContactInfo((prev) => ({ ...prev, email: e.target.value }))
              }
              required
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="company">Company *</Label>
            <Input
              id="company"
              value={contactInfo.company}
              onChange={(e) =>
                setContactInfo((prev) => ({ ...prev, company: e.target.value }))
              }
              required
            />
          </div>
          <Button type="submit" className="w-full bg-[#FF6F61] hover:bg-[#FF5B4D]" disabled={loading}>
            {loading ? "Processing..." : "View Results"}
          </Button>
        </form>
      </DialogContent>
    </Dialog>
  );
};